/* tslint:disable */
/* eslint-disable */
/**
 * MVC Games
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ConfirmAccountRequest
 */
export interface ConfirmAccountRequest {
    /**
     * A URL to the JSON Schema for this object.
     * @type {string}
     * @memberof ConfirmAccountRequest
     */
    readonly $schema?: string;
    /**
     * Favorite team ID
     * @type {number}
     * @memberof ConfirmAccountRequest
     */
    favoriteTeamId: number;
    /**
     * Password
     * @type {string}
     * @memberof ConfirmAccountRequest
     */
    password: string;
    /**
     * Token
     * @type {string}
     * @memberof ConfirmAccountRequest
     */
    token: string;
    /**
     * Username
     * @type {string}
     * @memberof ConfirmAccountRequest
     */
    username: string;
}

/**
 * Check if a given object implements the ConfirmAccountRequest interface.
 */
export function instanceOfConfirmAccountRequest(value: object): value is ConfirmAccountRequest {
    if (!('favoriteTeamId' in value) || value['favoriteTeamId'] === undefined) return false;
    if (!('password' in value) || value['password'] === undefined) return false;
    if (!('token' in value) || value['token'] === undefined) return false;
    if (!('username' in value) || value['username'] === undefined) return false;
    return true;
}

export function ConfirmAccountRequestFromJSON(json: any): ConfirmAccountRequest {
    return ConfirmAccountRequestFromJSONTyped(json, false);
}

export function ConfirmAccountRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConfirmAccountRequest {
    if (json == null) {
        return json;
    }
    return {
        
        '$schema': json['$schema'] == null ? undefined : json['$schema'],
        'favoriteTeamId': json['favorite_team_id'],
        'password': json['password'],
        'token': json['token'],
        'username': json['username'],
    };
}

export function ConfirmAccountRequestToJSON(json: any): ConfirmAccountRequest {
    return ConfirmAccountRequestToJSONTyped(json, false);
}

export function ConfirmAccountRequestToJSONTyped(value?: Omit<ConfirmAccountRequest, '$schema'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'favorite_team_id': value['favoriteTeamId'],
        'password': value['password'],
        'token': value['token'],
        'username': value['username'],
    };
}

